export default __webpack_public_path__ + "admin_sales.html";